import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FlashHotelAboutHotelModal from './Modals/FlashHotelAboutHotelModal'
import React, { useCallback, useContext } from 'react'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import MarkdownRender from 'LuxKit/MarkdownRender'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'LuxKit/Typography/Heading'

const MarkdownWrapper = styled.div`
  max-height: ${rem(94)};
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${rem(32)};
    background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
    opacity: 1;
    pointer-events: none;
  }
`

interface Props {
  descriptionMarkdown: string
  facilitiesMarkdown: string
}

function FlashHotelOfferDescription(props: Props) {
  const { descriptionMarkdown, facilitiesMarkdown } = props
  const showModal = useContext(ModalContext)
  const openHighlightsAndInclusions = useCallback(async() => {
    showModal(
      <FlashHotelAboutHotelModal descriptionMarkdown={descriptionMarkdown} facilitiesMarkdown={facilitiesMarkdown} />,
    )
  }, [descriptionMarkdown, facilitiesMarkdown, showModal])

  return <VerticalSpacer gap={12}>
    <Heading variant="heading3">About the hotel</Heading>
    <VerticalSpacer gap={4}>
      <MarkdownWrapper>
        <MarkdownRender content={descriptionMarkdown} fontSize="large"/>
      </MarkdownWrapper>
      <TextLink size="medium" onClick={openHighlightsAndInclusions}>Read more</TextLink>
    </VerticalSpacer>
  </VerticalSpacer>
}

export default FlashHotelOfferDescription
